import { render, staticRenderFns } from "./QuestionsSubPage.vue?vue&type=template&id=4e515538&"
import script from "./QuestionsSubPage.vue?vue&type=script&lang=ts&"
export * from "./QuestionsSubPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports